import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent {
  
}